/**
 *
 */

import React, { Fragment, PureComponent } from 'react';
import styled from 'styled-components';
import { Row, Col, Carousel, Modal } from 'antd';
import endPoints from '../../config/endPoints';
import { SubTitle, VideoIframe } from '../../components';
import LandingContainer from '../../components/LandingContainer';


const LandingAwardsUI = styled.section`
  background: transparent linear-gradient(282deg, #FFFFFF 0%, #EAECF4 100%);
  padding: 40px 0px 80px;
.slick-dots{
  height: auto;
    bottom: -45px;
    left: 0px;
    text-align: center;
    li{
      background: ${({ theme }) => theme.transparentColor};
      border:${({ theme }) => theme.lightGray} solid 1px;
      width:14px;
      height:14px;
      border-radius:50%;
      cursor:pointer;
      &.slick-active{
        background: ${({ theme }) => theme.transparentColor};
        border:none;
        button{
          background: ${({ theme }) => theme.primaryColor};
          width:14px;
          height:14px;
          border: 4px solid ${({ theme }) => theme.secondaryColor};
          border-radius: 50%;
          &:before{
          color: ${({ theme }) => theme.transparentColor};
        }
        }
      }
      button{
          height:10px;
          &:before{
          color: ${({ theme }) => theme.transparentColor};
        }
      }
    }
}
.star-image{
  padding-top: 20px;
  .star{
    position: absolute;
    top: -20px;
    left: 135px;
  }
}
@media (max-width: ${({ theme: { breakpoints } }) => breakpoints[1]}) {
.award-img{
  img{
    width: 100% !important;
    padding: 10px;
  }
}
.leadership-response{
  margin-top: 45px;
}
.star{
  top: -10px !important;
}
};
`;

class LandingAwards extends PureComponent {
  constructor() {
    super();
    this.state = {
      isShowModal: false,
    };
    this.handleModal = this.handleModal.bind(this);
  }

  handleModal() {
    const { isShowModal } = this.state;
    this.setState({ isShowModal: !isShowModal });
  }

  renderModalUI() {
    return <VideoIframe height="300px" video="https://www.youtube.com/embed/HbCrtvPF_J4" />;
  }

  render() {
    const { isShowModal } = this.state;
    return (
      <Fragment>
        <Modal
          visible={isShowModal}
          classWrapper="fullScreen"
          onCancel={this.handleModal}
          footer={null}
          size="md"
        >
          <div className="margin-t-2">
            {isShowModal && this.renderModalUI() }
          </div>
        </Modal>
        <LandingAwardsUI>
          <LandingContainer>
            <Row align="middle" type="flex" justify="center" gutter={32}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12} className="text-center">
                <div className="star-image">
                  <img
                    src={endPoints.START_RIBBION_ICON.URL}
                    alt={endPoints.START_RIBBION_ICON.ALT}
                    className="star"
                  />
                  <SubTitle fontWeight="900" className="font-24">Awards we won</SubTitle>
                </div>
                <Carousel effect="scrollx">
                  <div className="award-img" >
                    <img
                      src={endPoints.ZAGGLE_AWARDS_WON.URL}
                      alt={endPoints.ZAGGLE_AWARDS_WON.ALT}
                      className="height-auto width-100"
                      height={778}
                      width={1388}
                    />
                  </div>
                </Carousel>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12} className="text-center leadership-response">
                <div className="star-image">
                  <img
                    src={endPoints.START_RIBBION_ICON.URL}
                    alt={endPoints.START_RIBBION_ICON.ALT}
                    className="star"
                  />
                  <SubTitle fontWeight="900" className="font-24">Leadership talk</SubTitle>
                </div>
                <Carousel effect="scrollx">
                  <div className="award-img pointer" onClick={() => this.handleModal()} role="presentation">
                    <img
                      src={endPoints.ZAGGLE_LEADERSHIP_TALK.URL}
                      alt={endPoints.ZAGGLE_LEADERSHIP_TALK.ALT}
                      className="height-auto width-100"
                      height={386}
                      width={714}
                    />
                  </div>
                </Carousel>
              </Col>
            </Row>
          </LandingContainer>
        </LandingAwardsUI>
      </Fragment>

    );
  }
}

export default LandingAwards;



// WEBPACK FOOTER //
// client/containers/NewLanding/Awards.jsx